<template>
  <path pid="0" d="M22 4.05a7 7 0 00-9.91 0l-6.8 6.75a1 1 0 00-.29.7v8.09L2.29 22.3a1 1 0 000 1.41l.1.08a1 1 0 001.32-.08L6.41 21h8.09a1 1 0 00.71-.29L22 14a7 7 0 000-9.95zM14.09 19H8.41l2-2h5.67zm6.44-6.46L18.07 15h-5.66l5.3-5.29a1 1 0 000-1.41l-.1-.09a1 1 0 00-1.32.09L7 17.59v-5.67l6.46-6.46a5 5 0 117.07 7.08z"/>
</template>
